function Plus3(props)
{
    return(
        <svg className={props.class} style={{...props.style}} viewBox="0 0 480 480"><path d="M480 240c0-47-54-87.7-132.7-107.3C327.7 54 287 0 240 0s-87.7 54-107.3 132.7C54 152.3 0 193 0 240s54 87.7 132.7 107.3C152.3 426 193 480 240 480s87.7-54 107.3-132.7C426 327.8 480 287 480 240Z"></path></svg>
    )
}

export default Plus3